import { Injectable } from '@angular/core';

@Injectable()
export class HighchartsOptions {
  public static highcharts_options = {
    colors: ['#F37A1F', '#D43B3B', '#749F4A', '#249ABE', '#FDC543', '#EDEDED', '#F6F6F6', '#c26219', '#B1B1B1', '#DADADA'],
    lang: {
      decimalPoint: ',',
      thousandsSep: '.'
    },
    xAxis: {
      lineColor: '#DADADA',
      labels: {
        style: {
          fontSize: '.688rem',
          color: '#404040'
        }
      }
    },
    yAxis: {
      lineColor: '#DADADA',
      labels: {
        style: {
          fontSize: '.688rem',
          color: '#404040'
        }
      }
    }
  }
}
